
export * from './basic-table.component';
export * from './basic-table-helper.utils';


// WEBPACK FOOTER //
// ./src/app/shared/datatable/basic/index.ts